// src/components/ContactView.jsx
import React from 'react';
import { useSheet } from '../hooks/useSheet';

export default function ContactView({ sheetId, sheetName }) {
  const rows = useSheet(sheetId, sheetName);

  return (
    <section className="dashboard-section contact-view">
      <div className="section-heading">
        <div>
          <span className="section-kicker">PROGRAM DIRECTORY</span>
          <h2>{sheetName}</h2>
          <p>Quick access to operational and support contacts.</p>
        </div>
      </div>

      <div className="contact-list">
        {(rows || []).slice(1).map((row, i) => {
          const name = row[0];
          const rawPhone = row[2] || '';
          const digits = rawPhone.toString().replace(/\D+/g, '');
          if (!name) return null;

          if (!digits) {
            return (
              <div key={i} className="contact-item">
                <div className="contact-avatar" aria-hidden="true">{String(name).trim().charAt(0).toUpperCase()}</div>
                <div className="contact-copy">
                  <span className="contact-name">{name}</span>
                  <span className="contact-meta">Contact information unavailable</span>
                </div>
              </div>
            );
          }

          const callHref = `tel:+${digits}`;
          const smsHref = `sms:+${digits}`;
          const showMessage = name !== 'UC Davis' && name !== 'Fire Dispatch';

          return (
            <div key={i} className="contact-item">
              <div className="contact-main">
                <div className="contact-avatar" aria-hidden="true">{String(name).trim().charAt(0).toUpperCase()}</div>
                <div className="contact-copy">
                  <span className="contact-name">{name}</span>
                  <span className="contact-meta">Tap to connect</span>
                </div>
              </div>
              <div className="contact-actions">
                <a href={callHref} className="contact-action contact-action-primary">Call</a>
                {showMessage && <a href={smsHref} className="contact-action">Message</a>}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
